import React from "react";
import "../../../reusableComponents/WarningModal/WarningModal.scss";
import WarningIcon from "../../../assets/icons/ErronIconsClose.svg";
import CloseBtn from "../../../assets/icons/ClosebuttonModal.svg";
import {useDispatch, useSelector} from "react-redux";
import {clearErrors} from "../../../store/reducers/error";
import {capitalizeFirstLetter} from "../../../utils/helpers/string";

function WarningModal() {
  const dispatch = useDispatch();
  const [isClosing, setIsClosing] = React.useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      dispatch(clearErrors());
      setIsClosing(false);
    }, 400);
  };

  const {title, msg, status} = useSelector((state) => state.error);

  const displayMessage = (typeof msg === "string" && msg.trim().length > 0) 
    ? msg 
    : (status === 500 ? "Internal server error. Please try again later." : "");

  // Use status as the primary visibility switch for Alerts
  return status ? (
    <div className="warning_modal_overlay" onClick={handleClose}>
      <div
        className={`warning_modal_container warningPopupContainer ${
          isClosing ? "closing" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popupIcon">
          <img
            src={WarningIcon}
            alt="warning"
          />
        </div>

        <div className="titleContent">
          <h1>{title || "Warning"}</h1>
          <p>{capitalizeFirstLetter(displayMessage)}</p>
        </div>

        <div className="actionArea">
          <button
            className="warning_modal_close_btn"
            onClick={handleClose}
          >
            {"Close"}
          </button>
          <img
            src={CloseBtn}
            alt="Close"
            onClick={handleClose}
            className="closeBtnSect"
          />
        </div>
      </div>
    </div>
  ) : (
    null
  );
}

export default WarningModal;
